function debounce(f, ms) {
  let isCooldown = false

  return function wrapper() {
    if (isCooldown) return

    // eslint-disable-next-line prefer-rest-params
    f.apply(this, arguments)

    isCooldown = true

    setTimeout(() => {
      isCooldown = false
    }, ms)
  }
}

export default debounce
